import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../config";
import $ from "jquery";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [schoolCode, setSchoolCode] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const modalRef = useRef(null);

  const handleLogin = async () => {
    if (!schoolCode || !password) {
      Swal.fire("warning", "Please enter Login ID and Password", "warning");
      return;
    }
    if (schoolCode?.toUpperCase() === "BOARD") {
      Swal.fire(
        "warning",
        "Please enter correct Center Code and Password",
        "warning",
      );
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/Auth/Login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          loginid: schoolCode,
          password: password,
        }),
      });

      let data;
      try {
        data = await response.json();
      } catch (err) {
        throw new Error("Invalid JSON response");
      }

      if (response.ok) {
        console.log(data.data);
        const sessionId = new Date().getTime();
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("schoolName", data.data.cent_name);
        localStorage.setItem("CentCode", data.data.cent_code);
        window.dispatchEvent(new Event("storage"));
        const stat = 1;
        if (data.data.PASSWORD_CHANGE === "YES") {
          openModal();
        } else {
          navigate("/dashboard");
        }
      } else {
        Swal.fire(
          "Error",
          data?.message || "Invalid login credentials",
          "error",
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  const openModal = () => {
    if (modalRef.current) {
      $(modalRef.current).addClass("show").css("display", "block");
      $("body")
        .addClass("modal-open")
        .append('<div class="modal-backdrop fade show"></div>');
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      $(modalRef.current).removeClass("show").css("display", "none");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    }
  };

  return {
    loading,
    showPassword,
    schoolCode,
    password,
    setShowPassword,
    setSchoolCode,
    setPassword,
    handleLogin,
    openModal,
    closeModal,
    modalRef,
  };
};

export default useLogin;
